import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[xCopyText]',
})
export class CopyTextDirective {
  @Input()
  public xCopyText: string;

  private navigator: Navigator = navigator;

  @HostListener('click')
  public async copyText(): Promise<void> {
    const clipboard = this.navigator.clipboard;
    await clipboard.writeText(this.xCopyText);
  }
}
